import type { RouterOutputs } from "~/utils/trpc";

export type UserType = RouterOutputs["user"]["getBySession"];

export type UserPageType = NonNullable<RouterOutputs["user"]["getById"]>;

export enum UserTabEnum {
  DECKS = "decks",
  COLLECTION = "collection",
  RENOWN = "renown",
  RESOURCES = "resources",
}
